<template>
  <div :class="'login-page '+mobileCss">
    <div class="login-page-header">
      <img src="../assets/etc.jpg">
      <span>{{ globalConfig.title }}</span>
    </div>
    <div class="login-page-body">
      <div class="login-page-body-left" v-if="!isMobilePhone"></div>
      <div class="login-page-body-right">
        <login-form @login="onLogin"></login-form>
      </div>
    </div>
    <div class="company">
      <div>
        <span>版权所有：{{ globalConfig.company}}</span>
        <span>联系电话：{{globalConfig.linkman}}</span>
      </div>
    </div>
  </div>
</template>

<script>

import BaseVue from "@/components/base/BaseVue";
import LoginForm from "@/components/LoginForm";

export default {
  extends: BaseVue,
  components: { LoginForm },

  data() {
    return {
    }
  },
  created() {
    //防止被iframe引用
    if(document.location.href != top.document.location.href) {
      top.document.location.href = document.location.href;
    }
  },
  methods: {
    onLogin() {
      this.$router.push("/");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../css/variables";

.login-page {
  width: 100vw;
  min-width: 1024px;
  height: 100vh;
  background: #0A7AF2 url(../assets/login-1.svg) no-repeat;
  background-size: 100% 100%;

  &-header {
    position: absolute;
    top: 30px;
    left: 0;
    right: 0;
    width: 100vw;
    height: 80px;
    background: transparent;
    display: flex;
    flex-shrink: 1;
    align-items: center;
    img {
      height: 55px;
      margin-left: 8%;
    }

    span {
      color: #fff;
      font-size: 32px;
      font-weight: bold;
      padding: 0px 20px;
      flex-grow: 1;
    }
  }

  &-body {
    height: calc(100vh - 80px);
    display: flex;
    justify-content: center;
    align-items: center;

    &-left {
      width: 480px;
      height: 480px;
      //background: url('../assets/loginMiniBG.png') no-repeat;
      background-size: 100% 100%;
    }

    &-right {
      margin-left: 120px;
    }
  }
  .company{
    color: #ffffff;
    position: absolute;
    right: 0px;
    bottom: 10px;
    text-align: center;
    line-height: 24px;
    .el-link+.el-link{
      margin-left: 30px
    }
    div{
      span{
        margin-right: 20px;
      }
    }
  }
}
.login-page.mobile{
  min-width: auto;
  .login-page-body{
    .login-page-body-right {
      margin-left: 0px;
    }
  }
}
</style>
